import React, { Component } from 'react';
import secondaryApp from '../BD/secondaryApp';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import './modal.css';



import firebase from 'firebase';


const database=firebase.database();


const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };


class Socios_Modal extends Component{

	constructor(){

		super();

		this.state={

			isActive:false,
			template:false
		}

		this.sociosRef = database.ref().child('Socios');
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleKeyPressLetras=this.handleKeyPressLetras.bind(this);
	}

	componentWillMount(){

		Modal.setAppElement('body');
	}


	toggleModal=()=>{

		this.setState({

			isActive:!this.state.isActive
		})

	}
	
	handleSubmit(event){
	
		
		
		
		let contrasena=this.contrasena.value;
		let confirm=this.confirm.value;
		let mail=this.correo.value;
		
		
	
		
		if(contrasena===confirm){

	
				
				secondaryApp.auth().createUserWithEmailAndPassword(mail,contrasena)
				.then(user => {
			
		
					
					database.ref().child('Socios').child(user.uid).update({
						
						correo:mail,
						contrasena:contrasena,
						Nombre:this.nombreSocios.value,
						Apellido:this.apellidoSocios.value,
						Estado:this.estadoSocios.value
						
					})

					
					Alert.success('Datos guardados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					
					this.toggleModal();
					
				})
				.catch(error =>{
				
						
					
				
					//Si no se logro crear la cuenta por error se elimina el registro del socio
					
				
					let msj='Error al ingresar usuario';
				
					if(error.code==='auth/email-already-in-use'){	
						msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
					}
					else if(error.code==='auth/invalid-email'){					
						msj='Dirección de correo electronico no valida.';					
					}
					
					else if(error.code==='auth/weak-password'){
						
						msj='La contraseña ingresada no es demasiado fuerte.';
							
					}

					Alert.error(msj, {
							effect: 'genie',
							position: 'bottom-right',
							timeout:2000			
					});		
				});					
						

					
		}else{
			
					Alert.warning('Las contraseñas ingresadas no coinciden', {
								effect: 'genie',
								position: 'bottom-right',
								timeout:2000			
					});
		
		}
	
		
		
		event.preventDefault();
		
		
		
	}

	
	handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32 && tecla!=91 ){			
			e.preventDefault();		
		}	
	}
	


	render(){

		return(

			<div className="Modal">

						
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
					
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
						
					
							<form method="POST" action="" onSubmit={this.handleSubmit}>

								<h3>Agregar Socios</h3>
								<hr/>
								<div className="form-group">
										<label htmlFor="nombre" >Nombre:</label>
										<input type="text" className="form-control" name="nombre"
											ref={input => {this.nombreSocios=input;}}
											onKeyPress={this.handleKeyPressLetras}
											required autoComplete="off"											
											placeholder="Nombre"
											
										 />
									</div>

									<div className="form-group">
										<label htmlFor="apellido" >Apellido:</label>
										<input type="text" className="form-control" name="apellido" 
											ref={input => {this.apellidoSocios=input;}}
											onKeyPress={this.handleKeyPressLetras}
											required autoComplete="off"
											placeholder="Apellido"
											
										/>
									</div>
									<div className="form-group">
										<label  htmlFor="correo" >Correo</label>
										<input type="email" className="form-control" name="correo"
										ref={input=>{this.correo=input}} required autoComplete="off" placeholder="Correo"										
										/>
									</div>
									<div className="form-group">
										<label htmlFor="contrasena"> Contraseña</label>
										<input type="password" className="form-control" name="contrasena"
										ref={input=>{this.contrasena=input}} required autoComplete="off" placeholder="Contraseña"
										/>
									</div>
									<div className="form-group">
										<label htmlFor="confirm">Confirmar Contraseña</label>
										<input type="password" className="form-control" name="confirm"
										ref={input=>{this.confirm=input}} required autoComplete="off" placeholder="Confirmar Contraseña"
										/>
									</div>
									

								
									<div className="form-group">
										<label htmlFor="estado">Estado:</label>
										<select className="form-control" name="estado"
										ref={input => {this.estadoSocios=input;}}
										
										
										>
										<option>Activo</option>
										<option>Inactivo</option>
										</select>
									</div>
									
								<hr/>
								<button className="btn btn-primary buttons" type="submit" >Guardar</button>
								</form>
								<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
							</Modal>

						

			</div>
		);
	}
}

export default Socios_Modal;



// WEBPACK FOOTER //
// ./src/Components/Socios/socios_modal.jsx